import * as Types from '../../../types/types.generated';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpdateRegulatoryDocumentWorkflowStatusMutationVariables = Types.Exact<{
  regulatoryDocumentId: Types.Scalars['ID'];
  workflowStatus: Types.WorkflowStatus;
}>;


export type UpdateRegulatoryDocumentWorkflowStatusMutation = { __typename?: 'Mutation', updateRegulatoryDocumentWorkflowStatus: { __typename?: 'RegulatoryDocument', id: string } };

export type UpdateGetexRegulationWorkflowStatusMutationVariables = Types.Exact<{
  getexRegulationId: Types.Scalars['ID'];
  workflowStatus: Types.WorkflowStatus;
}>;


export type UpdateGetexRegulationWorkflowStatusMutation = { __typename?: 'Mutation', updateGetexRegulationWorkflowStatus: { __typename?: 'GetexRegulation', id: string } };


export const UpdateRegulatoryDocumentWorkflowStatusDocument = gql`
    mutation UpdateRegulatoryDocumentWorkflowStatus($regulatoryDocumentId: ID!, $workflowStatus: WorkflowStatus!) {
  updateRegulatoryDocumentWorkflowStatus(
    regulatoryDocumentId: $regulatoryDocumentId
    workflowStatus: $workflowStatus
  ) {
    id
  }
}
    `;
export type UpdateRegulatoryDocumentWorkflowStatusMutationFn = Apollo.MutationFunction<UpdateRegulatoryDocumentWorkflowStatusMutation, UpdateRegulatoryDocumentWorkflowStatusMutationVariables>;

/**
 * __useUpdateRegulatoryDocumentWorkflowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateRegulatoryDocumentWorkflowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRegulatoryDocumentWorkflowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRegulatoryDocumentWorkflowStatusMutation, { data, loading, error }] = useUpdateRegulatoryDocumentWorkflowStatusMutation({
 *   variables: {
 *      regulatoryDocumentId: // value for 'regulatoryDocumentId'
 *      workflowStatus: // value for 'workflowStatus'
 *   },
 * });
 */
export function useUpdateRegulatoryDocumentWorkflowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateRegulatoryDocumentWorkflowStatusMutation, UpdateRegulatoryDocumentWorkflowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateRegulatoryDocumentWorkflowStatusMutation, UpdateRegulatoryDocumentWorkflowStatusMutationVariables>(UpdateRegulatoryDocumentWorkflowStatusDocument, options);
      }
export type UpdateRegulatoryDocumentWorkflowStatusMutationHookResult = ReturnType<typeof useUpdateRegulatoryDocumentWorkflowStatusMutation>;
export type UpdateRegulatoryDocumentWorkflowStatusMutationResult = Apollo.MutationResult<UpdateRegulatoryDocumentWorkflowStatusMutation>;
export type UpdateRegulatoryDocumentWorkflowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateRegulatoryDocumentWorkflowStatusMutation, UpdateRegulatoryDocumentWorkflowStatusMutationVariables>;
export const UpdateGetexRegulationWorkflowStatusDocument = gql`
    mutation UpdateGetexRegulationWorkflowStatus($getexRegulationId: ID!, $workflowStatus: WorkflowStatus!) {
  updateGetexRegulationWorkflowStatus(
    getexRegulationId: $getexRegulationId
    workflowStatus: $workflowStatus
  ) {
    id
  }
}
    `;
export type UpdateGetexRegulationWorkflowStatusMutationFn = Apollo.MutationFunction<UpdateGetexRegulationWorkflowStatusMutation, UpdateGetexRegulationWorkflowStatusMutationVariables>;

/**
 * __useUpdateGetexRegulationWorkflowStatusMutation__
 *
 * To run a mutation, you first call `useUpdateGetexRegulationWorkflowStatusMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateGetexRegulationWorkflowStatusMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateGetexRegulationWorkflowStatusMutation, { data, loading, error }] = useUpdateGetexRegulationWorkflowStatusMutation({
 *   variables: {
 *      getexRegulationId: // value for 'getexRegulationId'
 *      workflowStatus: // value for 'workflowStatus'
 *   },
 * });
 */
export function useUpdateGetexRegulationWorkflowStatusMutation(baseOptions?: Apollo.MutationHookOptions<UpdateGetexRegulationWorkflowStatusMutation, UpdateGetexRegulationWorkflowStatusMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateGetexRegulationWorkflowStatusMutation, UpdateGetexRegulationWorkflowStatusMutationVariables>(UpdateGetexRegulationWorkflowStatusDocument, options);
      }
export type UpdateGetexRegulationWorkflowStatusMutationHookResult = ReturnType<typeof useUpdateGetexRegulationWorkflowStatusMutation>;
export type UpdateGetexRegulationWorkflowStatusMutationResult = Apollo.MutationResult<UpdateGetexRegulationWorkflowStatusMutation>;
export type UpdateGetexRegulationWorkflowStatusMutationOptions = Apollo.BaseMutationOptions<UpdateGetexRegulationWorkflowStatusMutation, UpdateGetexRegulationWorkflowStatusMutationVariables>;